import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Core2Config} from '../../shared/core2Config';
import {WfIssueHdrContainerModel} from "../../../../../../models/aggregates/wf/issue";

@Injectable({providedIn: 'root'})
export class WfIssueHdrService extends BaseApiTemplateService<WfIssueHdrContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-hdrs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-hdrs';
    this.httpClient = http;
  }
}
